import JSZip from 'jszip';
import mime from 'mime/lite';

function getUniqueName(img: JSZip, name: string, ext: string): string {
  let i = 0;

  const correctName = name.slice(0, name.lastIndexOf('.'));
  let fileName = `${correctName}.${ext}`;

  while (img.file(fileName)) {
    fileName = `${name}_${++i}.${ext}`;
  }

  return fileName;
}

interface IImageData {
  url: string;
  name: string;
}

const downloadImagesBySrc = async (imageData: IImageData[], downloadFileName: string): Promise<Blob> => {
  const zip = new JSZip();
  const folder = zip.folder(downloadFileName);

  if (!folder) {
    return new Blob();
  }

  await Promise.all(imageData.map(async ({ url, name }) => {
    const blob = await fetch(url).then(r => r.blob());
    const ext = mime.getExtension(blob.type);
    const fileName = getUniqueName(folder, name, ext);
    folder.file(fileName, blob);
  }));

  const content = await zip.generateAsync({ type: 'blob' });
  return content;
};

export default downloadImagesBySrc;
